import React, {Fragment} from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from "./Home/Home";
import AllEvents from "./AllEvents/AllEvents";

const Diary = () =>  {
	const diaryRoutes =
		(<Routes>
			<Route path="/" exact element={<Home />} />
			<Route path="/:userId" strict element={<AllEvents />} />
			<Route path="/:userId/events/:eventId" strict element={<AllEvents />} />
			<Route path="/:userId/:year" strict element={<AllEvents />} />
			<Route path="/:userId/:year/:month" strict element={<AllEvents />} />
			<Route path="/:userId/:year/:month/:day" strict element={<AllEvents />} />
		</Routes>);

	return (
		<Fragment>
			{diaryRoutes}
		</Fragment>
	);
}

export default Diary;
